/* CacheBuster component */
import React from 'react';
import fetchIntercept from 'fetch-intercept';
import packageJson from '../../../../package.json';

global.appVersion = packageJson.version;
function isLatestVersion(latestVersion) {
  const currentVersion = global.appVersion;
  const latestVersionArray = latestVersion.split('.');
  const currentVersionArray = currentVersion.split('.');
  const latestMajorVersion = parseInt(latestVersionArray[0], 10);
  const latestMinorVersion = parseInt(latestVersionArray[1], 10);
  const latestPatchVersion = parseInt(latestVersionArray[2], 10);
  const currentMajorVersion = parseInt(currentVersionArray[0], 10);
  const currentMinorVersion = parseInt(currentVersionArray[1], 10);
  const currentPatchVersion = parseInt(currentVersionArray[2], 10);
  if (latestMajorVersion > currentMajorVersion) return false;
  if (latestMinorVersion > currentMinorVersion) return false;
  if (latestPatchVersion > currentPatchVersion) return false;
  return true;
}

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isLatestVersion: true,
      refreshCacheAndReload: () => {
        console.log('Clearing cache and hard reloading...');
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then((names) => {
            for (const name of names) caches.delete(name);
          });
        }
        alert('Hay una nueva versión de la aplicación. Se va a proceder a actualizar.');
        window.location.reload(true);
      },
    };
  }

  componentDidMount() {
    const self = this;
    fetchIntercept.register({
      response(response) {
        response.clone().json().then((data) => {
          const { appVersion: serverAppVersion } = data;
          const shouldForceRefresh = !isLatestVersion(serverAppVersion);
          if (shouldForceRefresh) {
            self.setState({ loading: false, isLatestVersion: false });
          } else {
            self.setState({ loading: false, isLatestVersion: true });
          }
        });
        return response;
      },
    });
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
  }
}
export default CacheBuster;
